<script setup>
import { provide, reactive, getCurrentInstance } from 'vue';

const variables = reactive({
    debug: false,
})

provide('debug', variables)
</script>

<template>
    <slot />
</template>